import { render, staticRenderFns } from "./newsletterKS.vue?vue&type=template&id=3ded6f7f"
import script from "./newsletterKS.vue?vue&type=script&lang=js"
export * from "./newsletterKS.vue?vue&type=script&lang=js"
import style0 from "./newsletterKS.vue?vue&type=style&index=0&id=3ded6f7f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports